/**
 * Splits a key's stacks against the set a role can grant. Used both to warn
 * when a role change left a key pinned to stacks it no longer reaches, and
 * to find which of a key's requested stacks still need re-attesting.
 */
export function partitionStackIds(
  stackIds: string[],
  grantableIds: Set<string>,
): { reachable: string[]; unreachable: string[] } {
  return {
    reachable: stackIds.filter((id) => grantableIds.has(id)),
    unreachable: stackIds.filter((id) => !grantableIds.has(id)),
  };
}
